import tagCreateDirective from './tagCreateDirective';
import tagListDirective from './tagListDirective';
import tagDirective from './tagDirective';

import tagSwitchService from './tagSwitchService';

import deleteTag from './services/deleteTag';
import getAllEnquiryTags from './services/getAllEnquiryTags';
import getTagList from './services/getTagList';
import saveTag from './services/saveTag';

export default function (app) {
    app.directive('tagCreate', tagCreateDirective);
    app.directive('tagList', tagListDirective);
    app.directive('tags', tagDirective);

    app.factory('tagSwitchService', tagSwitchService);

    app.factory('deleteTag', deleteTag);
    app.factory('getAllEnquiryTags', getAllEnquiryTags);
    app.factory('getTagList', getTagList);
    app.factory('saveTag', saveTag);
}



// WEBPACK FOOTER //
// ./Client/app/tasks/tags/index.js